export type Movie = {
  id: string;
  title: string;
  poster: string;
  backdrop: string;
  genres: string[];
  genreSlugs: string[];
  year: number;
  director: string;
  cast: string[];
  duration: number;
  releaseDate: string;
  language: string;
  country: string;
  rating: number;
  views: number;
  synopsis: string;
  featured?: boolean;
};

export type Category = {
  slug: string;
  name: string;
  icon: string;
  desc: string;
};

export const categories: Category[] = [
  { slug: "action", name: "动作", icon: "ri-sword-line", desc: "枪战、格斗、爆破，肾上腺素飙升的燃爆时刻，汇集最新动作大片。" },
  { slug: "drama", name: "剧情", icon: "ri-film-line", desc: "以人物与情感为核心，讲述打动人心的故事，细品人生百态。" },
  { slug: "comedy", name: "喜剧", icon: "ri-emotion-happy-line", desc: "轻松解压的欢乐时光，让人笑出声的喜剧佳作合集。" },
  { slug: "scifi", name: "科幻", icon: "ri-rocket-2-line", desc: "星际远航与未来幻想，探索科技与宇宙的无限可能。" },
  { slug: "romance", name: "爱情", icon: "ri-heart-3-line", desc: "怦然心动与细水长流，关于爱与羁绊的温柔篇章。" },
  { slug: "horror", name: "恐怖", icon: "ri-ghost-line", desc: "惊悚刺激、毛骨悚然，挑战胆量的深夜必看之选。" },
  { slug: "suspense", name: "悬疑", icon: "ri-search-eye-line", desc: "层层反转、迷雾重重，跟着线索一起推理真相。" },
  { slug: "animation", name: "动画", icon: "ri-magic-line", desc: "天马行空的想象力，全年龄段的温暖与治愈。" },
  { slug: "crime", name: "犯罪", icon: "ri-fingerprint-line", desc: "罪案追踪与人性博弈，正义与黑暗的终极较量。" },
  { slug: "adventure", name: "冒险", icon: "ri-compass-3-line", desc: "踏上未知旅程，去远方寻找宝藏与自由。" },
];

export const movies: Movie[] = [
  {
    id: "m001",
    title: "星际迷航者",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20lone%20astronaut%20silhouette%20against%20a%20glowing%20nebula%2C%20deep%20blue%20tones%20with%20warm%20orange%20highlights%2C%20dramatic%20space%20opera%20lighting%2C%20high%20detail%20illustration&width=600&height=900&seq=poster-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20wide%20shot%2C%20futuristic%20spaceship%20traveling%20through%20a%20vast%20colorful%20nebula%2C%20deep%20blue%20space%20with%20orange%20starlight%2C%20epic%20scale%2C%20dramatic%20atmosphere%2C%20film%20still&width=1600&height=900&seq=backdrop-01&orientation=landscape",
    genres: ["科幻", "冒险"],
    genreSlugs: ["scifi", "adventure"],
    year: 2024,
    director: "陈亦航",
    cast: ["林川", "苏念", "周毅然"],
    duration: 138,
    releaseDate: "2024-06-21",
    language: "国语 / 英语",
    country: "中国大陆",
    rating: 8.7,
    views: 986000,
    synopsis: "当人类第一艘远航飞船在深空失联，一支临时组建的救援小队踏上了穿越星云的旅程。他们面对的不只是未知的宇宙文明，还有彼此之间难以言说的秘密。在浩瀚星海中，每个人都要重新定义什么是家、什么是归途。",
    featured: true,
  },
  {
    id: "m002",
    title: "暗夜追凶",
    poster: "https://readdy.ai/api/search-image?query=Noir%20crime%20thriller%20movie%20poster%2C%20detective%20in%20a%20rainy%20neon%20alley%2C%20dark%20blue%20shadows%20with%20amber%20streetlight%2C%20moody%20mysterious%20atmosphere%2C%20cinematic%20illustration%20high%20detail&width=600&height=900&seq=poster-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%2C%20neon%20signs%20reflecting%20on%20wet%20asphalt%2C%20dark%20blue%20noir%20cinematic%20mood%2C%20lone%20figure%20in%20the%20distance%2C%20film%20noir%20atmosphere&width=1600&height=900&seq=backdrop-02&orientation=landscape",
    genres: ["犯罪", "悬疑"],
    genreSlugs: ["crime", "suspense"],
    year: 2023,
    director: "高铭",
    cast: ["赵晋", "何婉", "马东阳"],
    duration: 124,
    releaseDate: "2023-11-03",
    language: "国语",
    country: "中国大陆",
    rating: 8.3,
    views: 742000,
    synopsis: "一连串看似毫无关联的失踪案，将一位被停职的老刑警重新拉回案件现场。随着调查深入，他发现所有线索都指向二十年前那场从未结案的旧案。真相藏在雨夜的城市角落，而凶手可能就在身边。",
    featured: true,
  },
  {
    id: "m003",
    title: "心跳信号",
    poster: "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%2C%20young%20couple%20standing%20under%20warm%20sunset%20light%2C%20soft%20orange%20and%20cream%20tones%2C%20tender%20emotional%20atmosphere%2C%20cinematic%20portrait%20illustration&width=600&height=900&seq=poster-03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20city%20rooftop%2C%20two%20silhouettes%20standing%20apart%2C%20soft%20orange%20sunset%20light%2C%20romantic%20cinematic%20wide%20shot%2C%20gentle%20emotional%20mood&width=1600&height=900&seq=backdrop-03&orientation=landscape",
    genres: ["爱情", "剧情"],
    genreSlugs: ["romance", "drama"],
    year: 2024,
    director: "苏晴",
    cast: ["许安", "程莉", "吴昊"],
    duration: 118,
    releaseDate: "2024-08-09",
    language: "国语",
    country: "中国大陆",
    rating: 8.1,
    views: 654000,
    synopsis: "一位深夜电台主播，和一个从不露面的神秘听众，因为一通电话结下不解之缘。他们的声音在城市上空相遇，却始终隔着一段距离。当真相揭开，心跳的信号能否指引他们走到彼此身边。",
    featured: true,
  },
  {
    id: "m004",
    title: "笑闹一家人",
    poster: "https://readdy.ai/api/search-image?query=Lighthearted%20family%20comedy%20movie%20poster%2C%20cheerful%20family%20gathered%20in%20bright%20living%20room%2C%20warm%20orange%20and%20yellow%20tones%2C%20playful%20joyful%20atmosphere%2C%20colorful%20illustration&width=600&height=900&seq=poster-04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Bright%20cozy%20family%20living%20room%20with%20warm%20sunlight%2C%20colorful%20furniture%20and%20toys%2C%20playful%20joyful%20cinematic%20mood%2C%20warm%20orange%20tones%2C%20feel%20good%20atmosphere&width=1600&height=900&seq=backdrop-04&orientation=landscape",
    genres: ["喜剧", "剧情"],
    genreSlugs: ["comedy", "drama"],
    year: 2023,
    director: "刘一鸣",
    cast: ["孙悦", "钱多多", "李开心"],
    duration: 106,
    releaseDate: "2023-10-01",
    language: "国语",
    country: "中国大陆",
    rating: 7.8,
    views: 512000,
    synopsis: "为了迎接久别重逢的亲戚，三个性格迥异的家庭凑到一起过假期。从争抢遥控器到合伙策划惊喜，一连串啼笑皆非的意外接连上演。笑闹背后，是中国人最熟悉的烟火与温情。",
  },
  {
    id: "m005",
    title: "幽林古宅",
    poster: "https://readdy.ai/api/search-image?query=Horror%20movie%20poster%2C%20decaying%20mansion%20in%20misty%20forest%2C%20cold%20blue%20gray%20tones%20with%20eerie%20light%2C%20creepy%20dread%20atmosphere%2C%20dark%20cinematic%20illustration&width=600&height=900&seq=poster-05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Foggy%20dark%20forest%20with%20abandoned%20mansion%2C%20bare%20twisted%20trees%2C%20cold%20blue%20gray%20horror%20lighting%2C%20creepy%20unsettling%20cinematic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=backdrop-05&orientation=landscape",
    genres: ["恐怖", "悬疑"],
    genreSlugs: ["horror", "suspense"],
    year: 2022,
    director: "韩冰",
    cast: ["郑楠", "白露", "徐成"],
    duration: 98,
    releaseDate: "2022-07-15",
    language: "国语",
    country: "中国大陆",
    rating: 7.2,
    views: 433000,
    synopsis: "五位年轻人受邀前往一座隐藏在密林深处的古宅进行调研，却接连遭遇无法解释的异象。随着夜晚降临，古宅尘封的往事一点点浮出水面。他们很快发现，真正可怕的并不是这座房子，而是被遗忘的秘密。",
  },
  {
    id: "m006",
    title: "钢铁黎明",
    poster: "https://readdy.ai/api/search-image?query=Action%20sci-fi%20movie%20poster%2C%20armored%20soldier%20standing%20against%20a%20burning%20city%2C%20steel%20gray%20and%20fiery%20orange%20tones%2C%20intense%20explosive%20atmosphere%2C%20bold%20cinematic%20illustration&width=600&height=900&seq=poster-06&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Futuristic%20war%20torn%20cityscape%20at%20dawn%2C%20armored%20figures%20advancing%20through%20smoke%20and%20sparks%2C%20steel%20gray%20and%20orange%20firelight%2C%20epic%20action%20cinematic%20still&width=1600&height=900&seq=backdrop-06&orientation=landscape",
    genres: ["动作", "科幻"],
    genreSlugs: ["action", "scifi"],
    year: 2024,
    director: "周野",
    cast: ["贺兰", "秦锋", "田小雅"],
    duration: 132,
    releaseDate: "2024-05-17",
    language: "国语",
    country: "中国大陆",
    rating: 8.5,
    views: 871000,
    synopsis: "在被机械军团占领的未来都市，一名失去记忆的士兵醒来时发现自己是唯一能启动最终防御系统的人。他必须在黎明到来之前穿越整座城市，找回属于自己的过去。每一步都可能是陷阱，每一次呼吸都关乎人类存亡。",
    featured: true,
  },
  {
    id: "m007",
    title: "逆流而上",
    poster: "https://readdy.ai/api/search-image?query=Inspirational%20drama%20movie%20poster%2C%20determined%20athlete%20climbing%20a%20steep%20slope%2C%20muted%20blue%20and%20warm%20sunrise%20tones%2C%20hopeful%20powerful%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-07&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Lone%20rowing%20athlete%20on%20a%20wide%20river%20at%20sunrise%2C%20mist%20over%20calm%20water%2C%20muted%20blue%20with%20warm%20golden%20light%2C%20hopeful%20inspirational%20cinematic%20mood&width=1600&height=900&seq=backdrop-07&orientation=landscape",
    genres: ["剧情"],
    genreSlugs: ["drama"],
    year: 2023,
    director: "方舟",
    cast: ["孟然", "章蕾", "袁浩"],
    duration: 112,
    releaseDate: "2023-09-08",
    language: "国语",
    country: "中国大陆",
    rating: 8.0,
    views: 398000,
    synopsis: "一个被伤病终结运动生涯的年轻人，回到家乡成为一支濒临解散的队伍的教练。面对质疑与失败，他带着一群不被看好的孩子，逆着所有人的偏见重新出发。有些梦想，值得拼尽全力。",
  },
  {
    id: "m008",
    title: "疯狂假期",
    poster: "https://readdy.ai/api/search-image?query=Adventure%20comedy%20movie%20poster%2C%20friends%20road%20trip%20in%20a%20vintage%20van%2C%20bright%20sky%20blue%20and%20sunny%20orange%20tones%2C%20fun%20energetic%20atmosphere%2C%20colorful%20cinematic%20illustration&width=600&height=900&seq=poster-08&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Open%20highway%20through%20desert%20with%20a%20vintage%20van%2C%20clear%20blue%20sky%20and%20warm%20sunlight%2C%20fun%20road%20trip%20adventure%20cinematic%20wide%20shot%2C%20energetic%20vibe&width=1600&height=900&seq=backdrop-08&orientation=landscape",
    genres: ["喜剧", "冒险"],
    genreSlugs: ["comedy", "adventure"],
    year: 2024,
    director: "雷楠",
    cast: ["方圆", "林一", "乔佳"],
    duration: 104,
    releaseDate: "2024-07-05",
    language: "国语",
    country: "中国大陆",
    rating: 7.6,
    views: 476000,
    synopsis: "四个性格不合的同事，为了公司奖品被迫组团自驾旅行。导航失灵、行李丢失、误入荒村，一路上事故不断。这场本该糟糕透顶的假期，却意外成了他们重新认识彼此的契机。",
  },
  {
    id: "m009",
    title: "深海迷航",
    poster: "https://readdy.ai/api/search-image?query=Sci-fi%20thriller%20movie%20poster%2C%20submarine%20diving%20into%20a%20dark%20trench%2C%20deep%20teal%20blue%20with%20eerie%20green%20glow%2C%20tense%20mysterious%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-09&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Deep%20ocean%20trench%20with%20a%20lone%20submarine%2C%20bioluminescent%20creatures%2C%20deep%20teal%20blue%20horror%20lighting%2C%20tense%20claustrophobic%20cinematic%20mood%2C%20high%20detail&width=1600&height=900&seq=backdrop-09&orientation=landscape",
    genres: ["科幻", "悬疑"],
    genreSlugs: ["scifi", "suspense"],
    year: 2023,
    director: "沈括",
    cast: ["黎川", "钟宁", "华承"],
    duration: 120,
    releaseDate: "2023-12-22",
    language: "国语 / 英语",
    country: "中国大陆",
    rating: 8.2,
    views: 561000,
    synopsis: "一支科考队潜入从未被人类抵达的深海海沟，寻找失联的调查潜艇。随着深度增加，通讯逐一中断，船舱外出现了不该存在的东西。在这片永恒黑暗里，他们面对的或许不是一个谜题，而是一种活着的意志。",
  },
  {
    id: "m010",
    title: "城市之光",
    poster: "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%2C%20city%20skyline%20at%20night%20with%20warm%20window%20lights%2C%20soft%20blue%20and%20amber%20tones%2C%20quiet%20poetic%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20dusk%2C%20thousands%20of%20warm%20window%20lights%2C%20soft%20blue%20twilight%20with%20amber%20glow%2C%20quiet%20poetic%20cinematic%20wide%20shot&width=1600&height=900&seq=backdrop-10&orientation=landscape",
    genres: ["剧情", "爱情"],
    genreSlugs: ["drama", "romance"],
    year: 2022,
    director: "安然",
    cast: ["顾清", "温馨", "罗宇"],
    duration: 108,
    releaseDate: "2022-11-11",
    language: "国语",
    country: "中国大陆",
    rating: 7.9,
    views: 344000,
    synopsis: "在一个人人都在奔忙的城市里，两个陌生人因为一次走错的地铁站相遇。他们各自背负着不为人知的疲惫，在夜里成为彼此的微光。天亮之后，他们能否留住这份短暂的温暖。",
  },
  {
    id: "m011",
    title: "影子特工",
    poster: "https://readdy.ai/api/search-image?query=Action%20spy%20thriller%20movie%20poster%2C%20silhouetted%20agent%20in%20a%20dark%20corridor%2C%20deep%20navy%20and%20sharp%20orange%20accents%2C%20sleek%20tense%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-11&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Dark%20sleek%20modern%20corridor%20with%20dramatic%20lighting%2C%20lone%20agent%20silhouette%2C%20deep%20navy%20with%20sharp%20orange%20highlights%2C%20tense%20spy%20thriller%20cinematic%20still&width=1600&height=900&seq=backdrop-11&orientation=landscape",
    genres: ["动作", "犯罪"],
    genreSlugs: ["action", "crime"],
    year: 2024,
    director: "卫疆",
    cast: ["高扬", "柳诗", "沈默"],
    duration: 128,
    releaseDate: "2024-03-29",
    language: "国语 / 英语",
    country: "中国大陆",
    rating: 8.4,
    views: 803000,
    synopsis: "一名被组织抛弃的顶级特工，为查明搭档死亡的真相，独自潜入一个横跨多国的地下网络。他隐于暗处，步步为营，却发现自己只是更大棋局中的一枚棋子。当影子开始反击，没有人是安全的。",
    featured: true,
  },
  {
    id: "m012",
    title: "时间旅人",
    poster: "https://readdy.ai/api/search-image?query=Sci-fi%20drama%20movie%20poster%2C%20figure%20walking%20through%20a%20glowing%20time%20portal%2C%20deep%20blue%20with%20warm%20orange%20light%20streaks%2C%20mysterious%20wondrous%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-12&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Surreal%20abstract%20time%20tunnel%20with%20glowing%20light%20streaks%2C%20deep%20blue%20space%20with%20warm%20orange%20energy%2C%20mysterious%20wondrous%20cinematic%20mood%2C%20high%20detail&width=1600&height=900&seq=backdrop-12&orientation=landscape",
    genres: ["科幻", "剧情"],
    genreSlugs: ["scifi", "drama"],
    year: 2023,
    director: "钱墨",
    cast: ["夏远", "纪云", "程澈"],
    duration: 116,
    releaseDate: "2023-08-18",
    language: "国语",
    country: "中国大陆",
    rating: 8.6,
    views: 617000,
    synopsis: "一位物理学家发明了能短暂回溯时间的手表，本想挽救一场意外，却发现每一次改变都会带来更深的代价。他在无数个相似的黄昏里反复奔跑，只为找到那个唯一正确的答案。有些爱，值得逆着时间再走一遍。",
  },
  {
    id: "m013",
    title: "午夜来电",
    poster: "https://readdy.ai/api/search-image?query=Horror%20thriller%20movie%20poster%2C%20ringing%20vintage%20phone%20in%20a%20dark%20room%2C%20cold%20blue%20black%20tones%20with%20faint%20red%20glow%2C%20creepy%20dread%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-13&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Dark%20empty%20hallway%20at%20midnight%20with%20a%20glowing%20phone%2C%20cold%20blue%20black%20horror%20lighting%2C%20unsettling%20cinematic%20atmosphere%2C%20deep%20shadows&width=1600&height=900&seq=backdrop-13&orientation=landscape",
    genres: ["恐怖", "悬疑"],
    genreSlugs: ["horror", "suspense"],
    year: 2024,
    director: "阎森",
    cast: ["毛宁", "温小雪", "石磊"],
    duration: 95,
    releaseDate: "2024-09-13",
    language: "国语",
    country: "中国大陆",
    rating: 7.4,
    views: 388000,
    synopsis: "每到午夜十二点，那部早已停机的旧电话都会准时响起。接起电话的人，会在七天后消失。当一位记者决定追查真相，她发现自己早已被卷入了这场无法挂断的噩梦。",
  },
  {
    id: "m014",
    title: "山间小屋",
    poster: "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%2C%20cozy%20wooden%20cabin%20in%20a%20green%20mountain%20valley%2C%20soft%20warm%20light%20through%20windows%2C%20tender%20peaceful%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-14&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Secluded%20wooden%20cabin%20in%20a%20misty%20green%20mountain%20valley%2C%20warm%20window%20light%2C%20soft%20natural%20tones%2C%20peaceful%20romantic%20cinematic%20wide%20shot&width=1600&height=900&seq=backdrop-14&orientation=landscape",
    genres: ["爱情", "剧情"],
    genreSlugs: ["romance", "drama"],
    year: 2023,
    director: "叶知秋",
    cast: ["林晚", "江野", "苏木"],
    duration: 110,
    releaseDate: "2023-04-14",
    language: "国语",
    country: "中国大陆",
    rating: 8.0,
    views: 295000,
    synopsis: "一位都市白领为逃离高压生活，租下了一座偏远山间小屋。她没想到，屋顶漏雨时来帮忙修瓦的邻居，会成为她重新认识生活的开始。在大山的四季里，两个受伤的人慢慢学会了告别与和解。",
  },
  {
    id: "m015",
    title: "荒野求生者",
    poster: "https://readdy.ai/api/search-image?query=Adventure%20survival%20movie%20poster%2C%20rugged%20survivor%20standing%20on%20a%20rocky%20cliff%2C%20earth%20brown%20and%20sky%20blue%20tones%2C%20gritty%20powerful%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-15&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Vast%20rugged%20wilderness%20with%20mountains%20and%20river%2C%20dramatic%20sky%2C%20earth%20tones%20with%20warm%20sunlight%2C%20gritty%20survival%20cinematic%20wide%20shot&width=1600&height=900&seq=backdrop-15&orientation=landscape",
    genres: ["冒险", "剧情"],
    genreSlugs: ["adventure", "drama"],
    year: 2022,
    director: "荒野明",
    cast: ["陆野", "安然", "山口"],
    duration: 122,
    releaseDate: "2022-05-20",
    language: "国语",
    country: "中国大陆",
    rating: 7.7,
    views: 267000,
    synopsis: "一场空难将一名普通工程师独自抛在无人荒野。为了活下去，他必须依靠有限的装备与头脑，对抗野兽、严寒和孤独。在一次次的绝境中，他找回了被城市生活磨去的勇气。",
  },
  {
    id: "m016",
    title: "爆笑教室",
    poster: "https://readdy.ai/api/search-image?query=Comedy%20movie%20poster%2C%20chaotic%20classroom%20with%20cheerful%20students%2C%20bright%20yellow%20and%20orange%20tones%2C%20fun%20energetic%20atmosphere%2C%20colorful%20cinematic%20illustration&width=600&height=900&seq=poster-16&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Bright%20cheerful%20school%20classroom%20with%20colorful%20decorations%2C%20playful%20energetic%20mood%2C%20warm%20yellow%20and%20orange%20lighting%2C%20feel%20good%20cinematic%20still&width=1600&height=900&seq=backdrop-16&orientation=landscape",
    genres: ["喜剧"],
    genreSlugs: ["comedy"],
    year: 2024,
    director: "郝乐",
    cast: ["周星", "毛豆", "丁冬"],
    duration: 100,
    releaseDate: "2024-04-12",
    language: "国语",
    country: "中国大陆",
    rating: 7.5,
    views: 341000,
    synopsis: "一位刚入职的年轻老师，接手了全校最让人头疼的班级。学生们古灵精怪，课堂上状况百出。为了让孩子们真正爱上学习，这位老师决定用最不按常理出牌的方式，和他们一起闹出满堂欢笑。",
  },
  {
    id: "m017",
    title: "沉默证人",
    poster: "https://readdy.ai/api/search-image?query=Mystery%20crime%20movie%20poster%2C%20lone%20figure%20in%20a%20dark%20courtroom%2C%20muted%20gray%20blue%20with%20a%20single%20warm%20light%2C%20tense%20quiet%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-17&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Empty%20dark%20courtroom%20with%20single%20beam%20of%20light%2C%20muted%20gray%20blue%20tones%2C%20tense%20quiet%20mystery%20cinematic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=backdrop-17&orientation=landscape",
    genres: ["悬疑", "犯罪"],
    genreSlugs: ["suspense", "crime"],
    year: 2023,
    director: "简默",
    cast: ["唐文", "虞晴", "傅远"],
    duration: 114,
    releaseDate: "2023-06-16",
    language: "国语",
    country: "中国大陆",
    rating: 8.1,
    views: 452000,
    synopsis: "一桩看似证据确凿的凶案开庭在即，唯一的目击者却始终保持沉默。一位执着的律师逐渐发现，证人的沉默背后，藏着比案件本身更沉重的秘密。当真相被说出口，没有人能全身而退。",
  },
  {
    id: "m018",
    title: "未来都市",
    poster: "https://readdy.ai/api/search-image?query=Cyberpunk%20sci-fi%20movie%20poster%2C%20figure%20standing%20before%20a%20towering%20neon%20megacity%2C%20deep%20blue%20with%20vivid%20orange%20neon%2C%20bold%20futuristic%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-18&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Vast%20futuristic%20megacity%20skyline%20at%20night%2C%20towering%20neon%20skyscrapers%2C%20deep%20blue%20with%20vivid%20orange%20neon%20glow%2C%20epic%20cyberpunk%20cinematic%20wide%20shot&width=1600&height=900&seq=backdrop-18&orientation=landscape",
    genres: ["科幻", "动作"],
    genreSlugs: ["scifi", "action"],
    year: 2024,
    director: "云航",
    cast: ["顾辰", "艾拉", "罗森"],
    duration: 134,
    releaseDate: "2024-02-14",
    language: "国语 / 英语",
    country: "中国大陆",
    rating: 8.3,
    views: 729000,
    synopsis: "在高度智能化的未来都市，一名街头信使意外获得了一段不该存在的记忆芯片。为了活下去，他必须穿越被企业统治的城市上层，把真相交给唯一能公开它的人。科技越发达，人心越值得被追问。",
    featured: true,
  },
  {
    id: "m019",
    title: "追风少年",
    poster: "https://readdy.ai/api/search-image?query=Sports%20drama%20movie%20poster%2C%20young%20cyclist%20racing%20on%20an%20open%20road%2C%20muted%20blue%20and%20warm%20sunrise%20tones%2C%20youthful%20determined%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-19&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Young%20cyclist%20racing%20along%20a%20winding%20coastal%20road%20at%20sunrise%2C%20muted%20blue%20with%20warm%20golden%20light%2C%20youthful%20energetic%20cinematic%20wide%20shot&width=1600&height=900&seq=backdrop-19&orientation=landscape",
    genres: ["剧情"],
    genreSlugs: ["drama"],
    year: 2023,
    director: "疾风",
    cast: ["许阳", "谢晓", "柳叶"],
    duration: 105,
    releaseDate: "2023-07-28",
    language: "国语",
    country: "中国大陆",
    rating: 7.8,
    views: 238000,
    synopsis: "来自小镇的少年，用一辆旧自行车骑出了自己的赛道。面对家人的反对和强手的轻视，他一次次跌倒又爬起。风从耳边呼啸而过，梦想从不需要被证明，只需要被坚持。",
  },
  {
    id: "m020",
    title: "暗涌",
    poster: "https://readdy.ai/api/search-image?query=Suspense%20drama%20movie%20poster%2C%20calm%20water%20surface%20hiding%20dark%20depths%2C%20deep%20blue%20gray%20tones%20with%20subtle%20warm%20light%2C%20quiet%20tense%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-20&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Calm%20dark%20lake%20surface%20at%20dusk%2C%20deep%20blue%20gray%20tones%20with%20faint%20warm%20horizon%2C%20quiet%20tense%20mystery%20cinematic%20wide%20shot%2C%20subtle%20ripples&width=1600&height=900&seq=backdrop-20&orientation=landscape",
    genres: ["悬疑", "剧情"],
    genreSlugs: ["suspense", "drama"],
    year: 2022,
    director: "沉舟",
    cast: ["周瑾", "白洲", "陆离"],
    duration: 118,
    releaseDate: "2022-10-07",
    language: "国语",
    country: "中国大陆",
    rating: 7.9,
    views: 276000,
    synopsis: "平静的小镇表面下暗流涌动，一起意外落水事件牵出了十几年前的旧账。返乡的青年记者在调查中发现，每个人都在守护着自己的秘密。真相如同水下的暗涌，一旦浮出水面便再也无法平息。",
  },
  {
    id: "m021",
    title: "魔幻森林",
    poster: "https://readdy.ai/api/search-image?query=Animated%20adventure%20movie%20poster%2C%20magical%20enchanted%20forest%20with%20glowing%20plants%2C%20vivid%20green%20with%20warm%20golden%20light%2C%20whimsical%20wondrous%20atmosphere%2C%20colorful%20illustration&width=600&height=900&seq=poster-21&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Magical%20enchanted%20forest%20with%20glowing%20plants%20and%20floating%20light%2C%20vivid%20green%20with%20warm%20golden%20glow%2C%20whimsical%20fairy%20tale%20cinematic%20wide%20shot&width=1600&height=900&seq=backdrop-21&orientation=landscape",
    genres: ["动画", "冒险"],
    genreSlugs: ["animation", "adventure"],
    year: 2024,
    director: "童梦",
    cast: ["小狸", "阿木", "石头"],
    duration: 96,
    releaseDate: "2024-01-26",
    language: "国语",
    country: "中国大陆",
    rating: 8.4,
    views: 495000,
    synopsis: "一个胆小的小狐狸，为了找回被偷走的森林之光，鼓起勇气踏进了传说中的魔幻森林。它结识了古怪的伙伴，闯过一道道谜题。原来最强大的魔法，是相信自己。",
  },
  {
    id: "m022",
    title: "机械之心",
    poster: "https://readdy.ai/api/search-image?query=Sci-fi%20romance%20movie%20poster%2C%20gentle%20android%20and%20a%20human%20reaching%20toward%20each%20other%2C%20soft%20blue%20with%20warm%20orange%20glow%2C%20tender%20sci-fi%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-22&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Soft%20futuristic%20room%20with%20warm%20ambient%20light%2C%20human%20and%20android%20silhouettes%2C%20gentle%20blue%20with%20orange%20glow%2C%20tender%20sci-fi%20cinematic%20mood&width=1600&height=900&seq=backdrop-22&orientation=landscape",
    genres: ["科幻", "爱情"],
    genreSlugs: ["scifi", "romance"],
    year: 2023,
    director: "芯语",
    cast: ["墨白", "安琪", "零号"],
    duration: 111,
    releaseDate: "2023-02-10",
    language: "国语",
    country: "中国大陆",
    rating: 8.2,
    views: 407000,
    synopsis: "在研究机构工作的她，意外唤醒了一台被判定报废的仿生机器人。随着相处渐深，她开始怀疑，所谓的心究竟是程序，还是某种更真实的东西。当机器学会去爱，人类是否也学会了珍惜。",
  },
  {
    id: "m023",
    title: "血色黎明",
    poster: "https://readdy.ai/api/search-image?query=Action%20war%20movie%20poster%2C%20soldiers%20advancing%20through%20smoke%20at%20dawn%2C%20muted%20gray%20blue%20with%20fiery%20orange%20light%2C%20gritty%20intense%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-23&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Battlefield%20at%20dawn%20with%20smoke%20and%20distant%20fires%2C%20soldiers%20advancing%2C%20muted%20gray%20blue%20with%20warm%20orange%20firelight%2C%20gritty%20war%20cinematic%20wide%20shot&width=1600&height=900&seq=backdrop-23&orientation=landscape",
    genres: ["动作", "剧情"],
    genreSlugs: ["action", "drama"],
    year: 2022,
    director: "关山",
    cast: ["铁军", "何勇", "林戈"],
    duration: 140,
    releaseDate: "2022-09-30",
    language: "国语",
    country: "中国大陆",
    rating: 8.5,
    views: 588000,
    synopsis: "在一场决定命运的战役中，一支临时拼凑的小分队奉命守住最后的高地。他们在黎明前最黑暗的时刻，用血肉之躯撑起了最后的防线。这不是关于胜利的故事，而是关于守护的意义。",
  },
  {
    id: "m024",
    title: "幸福终点站",
    poster: "https://readdy.ai/api/search-image?query=Warm%20feel%20good%20movie%20poster%2C%20smiling%20people%20at%20a%20sunlit%20train%20station%2C%20soft%20orange%20and%20cream%20tones%2C%20hopeful%20heartwarming%20atmosphere%2C%20cinematic%20illustration&width=600&height=900&seq=poster-24&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Sunlit%20train%20station%20platform%20with%20warm%20golden%20light%2C%20travelers%20and%20soft%20bokeh%2C%20hopeful%20heartwarming%20cinematic%20wide%20shot%2C%20warm%20tones&width=1600&height=900&seq=backdrop-24&orientation=landscape",
    genres: ["剧情", "喜剧"],
    genreSlugs: ["drama", "comedy"],
    year: 2024,
    director: "向暖",
    cast: ["沈知", "赵北", "时雨"],
    duration: 109,
    releaseDate: "2024-10-01",
    language: "国语",
    country: "中国大陆",
    rating: 8.0,
    views: 312000,
    synopsis: "一位在车站工作了大半辈子的老站长，即将迎来退休前的最后一天。来来往往的旅客带着各自的故事短暂停留，也悄然改变着他的决定。原来每一段旅程的终点，都可能是另一种幸福的开始。",
  },
];